// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yrVt","placeholdersHeader":"styles_placeholdersHeader__8LvIp","editorStyle":"styles_editorStyle__3hu8A","placeholdersBox":"styles_placeholdersBox__17AVJ"};